import type { Thread } from 'modules/Mails/hooks';
import { firstBy } from 'remeda';

export const getLastMail = (thread: Thread) =>
  firstBy(thread.mails, [mail => mail.date?.valueOf() ?? 0, 'desc']);
